import './Retention.scss';
import { ForwardedRef, forwardRef, useEffect, useState } from 'react';
import {
  Button,
  ButtonToolbar,
  Form,
  useToaster,
  Message,
  Textarea,
  NumberInput
} from 'rsuite';
import {
  deleteLocalRetentionUser,
  getLocalRetentionUser,
  useGetRetentionByIdQuery,
  useQuery,
  useSendRetentionMutation
} from '@monorepo/shared';
import { server } from '../../config/const';
import { useLocation, useNavigate } from 'react-router-dom';

const Retention = () => {
  const { pathname, state } = useLocation();
  const urlQuery = useQuery();
  const debug_key = state?.debug_key;
  const [email, setEmail] = useState<string>('');
  const [id, setId] = useState<string>('');
  const [formValue, setFormValue] = useState<Record<string, any>>({});
  const toaster = useToaster();
  const [sendRetention, submitRes] = useSendRetentionMutation();
  const navigate = useNavigate();

  const query = useGetRetentionByIdQuery(
    { id: id, email: email, server: server },
    { skip: !id || !email }
  );

  useEffect(() => {
    if (query?.isSuccess && query?.data.length) {
      const user = query.data?.[0];
      setFormValue({ ...user });
    }
  }, [query]);

  useEffect(() => {
    try {
      const user =
        getLocalRetentionUser() || state?.user || urlQuery.get('user');
      const dataString = atob(user || '');
      if (dataString) {
        const arr = dataString.split('+');
        if (arr.length > 1) {
          setId(arr[0]);
          setEmail(arr[1]);
        }
      }
    } catch (error) {
      console.warn('decode user retention url failed', error);
    } finally {
      deleteLocalRetentionUser();
    }
  }, []);

  const onSubmit = () => {
    console.info('submit instance retention', formValue);
    sendRetention({
      data: formValue,
      server: server
    });
  };
  const onCancel = () => {
    navigate(`/organization`, {
      state: {
        debug_key
      }
    });
  };

  useEffect(() => {
    if (submitRes?.isSuccess) {
      const header = 'VM Retention Submitted successfully!';
      const content = 'Will redirect to Organization Page ...';
      const message = (
        <Message
          showIcon
          type="success"
          closable
          header={header}
          onClose={() => {
            navigate(`/organization`, {
              state: {
                debug_key
              }
            });
          }}
        >
          {content}
        </Message>
      );
      toaster.push(message, {
        placement: 'topCenter',
        duration: 5000
      });
    } else if (submitRes?.isError) {
      const header = 'VM Retention Submitted Failed!';
      const message = (
        <Message showIcon type="warning" closable header={header}></Message>
      );
      toaster.push(message, {
        placement: 'topCenter',
        duration: 5000
      });
    }
  }, [submitRes]);
  return (
    <div className="retention-container">
      <div className="retention-form-container">
        <Form
          layout="horizontal"
          formValue={formValue}
          onChange={(formValue) => {
            setFormValue(formValue);
          }}
        >
          <Form.Group controlId="account_email">
            <Form.Label>Email</Form.Label>
            <Form.Control name="account_email" disabled={true} />
          </Form.Group>
          <Form.Group controlId="user_name">
            <Form.Label>User Name</Form.Label>
            <Form.Control name="user_name" disabled={true} />
          </Form.Group>
          <Form.Group controlId="account_id">
            <Form.Label>Account ID</Form.Label>
            <Form.Control name="account_id" disabled={true} />
          </Form.Group>
          <Form.Group controlId="image_type">
            <Form.Label>Image Type</Form.Label>
            <Form.Control name="image_type" disabled={true} />
          </Form.Group>
          <Form.Group controlId="cloud_instance_expiry_date">
            <Form.Label>Instance Expired Date</Form.Label>
            <Form.Control name="cloud_instance_expiry_date" disabled={true} />
          </Form.Group>
          <Form.Group controlId="user_manager">
            <Form.Label>Manager</Form.Label>
            <Form.Control name="user_manager" />
          </Form.Group>
          <Form.Group controlId="user_title">
            <Form.Label>User Title</Form.Label>
            <Form.Control name="user_title" />
          </Form.Group>
          <Form.Group controlId="user_office_location">
            <Form.Label>Office Location</Form.Label>
            <Form.Control name="user_office_location" />
          </Form.Group>
          <Form.Group controlId="number_of_fortigates">
            <Form.Label>Number of Fortigate</Form.Label>
            <Form.Control name="number_of_fortigates" accepter={NumberInput} />
          </Form.Group>
          <Form.Group controlId="purpose_of_instance">
            <Form.Label>Purpose of Instance</Form.Label>
            <Form.Control name="purpose_of_instance" accepter={Textarea} />
          </Form.Group>
          <Form.Group>
            <ButtonToolbar style={{ justifyContent: 'space-around' }}>
              <Button appearance="primary" onClick={onSubmit}>
                Submit
              </Button>
              <Button appearance="default" onClick={onCancel}>
                Cancel
              </Button>
            </ButtonToolbar>
          </Form.Group>
        </Form>
      </div>
    </div>
  );
};
export default Retention;
